import { TakweenKey, UserProfileType } from '@peekapak/types/DataProtocolTypes';

export function isTakweenAccount(
  userProfile: Pick<UserProfileType, 'licenseLevel' | 'keyRing'> | null | undefined,
): boolean {
  const hasTakweenKey = [
    TakweenKey.TAKWEEN_ALL_UNITS,
    TakweenKey.TAKWEEN_LIBRARY,
    TakweenKey.TAKWEEN_BUILDING_RESILIENCE,
    TakweenKey.TAKWEEN_FUTURE_READY,
  ].some((key) => userProfile?.keyRing?.includes(key));

  return userProfile?.licenseLevel === 'TAKWEEN' || hasTakweenKey;
}
